import { render, staticRenderFns } from "./ResultDetailInvestInRight.vue?vue&type=template&id=106144c5&scoped=true&"
import script from "./ResultDetailInvestInRight.vue?vue&type=script&lang=js&"
export * from "./ResultDetailInvestInRight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106144c5",
  null
  
)

export default component.exports